import { gql } from '@apollo/client';

export const EXPAND_TEXT_MUTATION = gql`
  mutation expandText(
    $organizationId: String!
    $config: ContentGenerationInput!
  ) {
    expandText(organizationId: $organizationId, config: $config) {
      ... on TextGenerated {
        suggestions {
          content
        }
      }
      ... on CommonError {
        code
        success
        message
        error
      }
    }
  }
`;
